import { SharedHttpServiceProvider } from '@/shared/api/SharedHttpServiceProvider';
import type { IHttpClient } from '@/shared/api/clients/HttpClient';
import { BuergschaftService } from '@/auftraggeber/api/services/buergschaft';
import { DokumentService } from '@/auftraggeber/api/services/dokument/dokument';
import { ProjektService } from '@/auftraggeber/api/services/projekt';
import { PartnerService } from '@/auftraggeber/api/services/partner';
import { RechtstextService } from '@/auftraggeber/api/services/rechtstext';
import { BuergschaftsauftragService } from '@/auftraggeber/api/services/buergschaftsauftrag.ts';
import { MitteilungService } from '@/auftraggeber/api/services/mitteilung.ts';
import { AvallinieService } from '@/auftraggeber/api/services/avallinie.ts';
import { KreditvertragService } from '@/auftraggeber/api/services/kreditvertrag.ts';

export class AuftraggeberHttpServiceProvider extends SharedHttpServiceProvider {
  public readonly buergschaft: BuergschaftService;

  public readonly dokument: DokumentService;

  public readonly projekt: ProjektService;

  public readonly partner: PartnerService;

  public readonly rechtstext: RechtstextService;

  public readonly buergschaftsauftrag: BuergschaftsauftragService;

  public readonly mitteilung: MitteilungService;

  public readonly avallinie: AvallinieService;

  public readonly kreditvertrag: KreditvertragService;

  constructor(httpClient: IHttpClient) {
    super(httpClient);
    this.buergschaft = new BuergschaftService(httpClient);
    this.dokument = new DokumentService(httpClient);
    this.projekt = new ProjektService(httpClient);
    this.partner = new PartnerService(httpClient);
    this.rechtstext = new RechtstextService(httpClient);
    this.buergschaftsauftrag = new BuergschaftsauftragService(httpClient);
    this.mitteilung = new MitteilungService(httpClient);
    this.avallinie = new AvallinieService(httpClient);
    this.kreditvertrag = new KreditvertragService(httpClient);
  }
}
